import { create } from "zustand";
import { ActionsKey } from "../../../common/models/Actions";
import {
  ChalandMaterialItemData,
  initialChalandMaterialPageState,
} from "../core/_model.chaland";
import {
  DefaultListResponse,
  DefaultListStateType,
} from "../../../common/models/StoreDefaultModel";

export type ActionedChalandMaterial = {
  data: ChalandMaterialItemData | null;
  action: ActionsKey;
};

type ChalandMaterialDataType = {
  chalandMaterialList: any;
  detail: ChalandMaterialItemData | null;
  actioned: ActionedChalandMaterial | null;
  totalItems?: number;
  setDetail: (detail: ChalandMaterialItemData | null) => void;
  setChalandMaterialList: (roles: DefaultListResponse | null) => void;
  setActioned: (act: ActionedChalandMaterial | null) => void;
};

export const useChalandMaterialStore = create<ChalandMaterialDataType>(
  (set) => ({
    chalandMaterialList: [],
    detail: null,
    actioned: null,
    totalItems: 0,
    setDetail: (detail) => set((state) => ({ detail })),
    setChalandMaterialList: (data) =>
      set((state) => ({
        chalandMaterialList: data?.member,
        totalItems: data?.totalItems,
      })),
    setActioned: (act) => set((state) => ({ actioned: act } as any)),
  })
);

export const useChalandMaterialListState = create<DefaultListStateType>(
  (set) => ({
    pageState: initialChalandMaterialPageState,
    setPageState: (pageState) => set((state) => ({ pageState })),
    resetPageState: () =>
      set(() => ({
        pageState: {
          page: 1,
          itemsPerPage: 10,
        },
      })),
  })
);
